import React from 'react';
import LegalDocument from '../components/LegalDocument';
import privacyPolicy from '../content/legal/privacy-policy.json';

function PrivacyPolicy() {
  return <LegalDocument document={privacyPolicy} />;
}

export default PrivacyPolicy;
